import { render } from "./UserRegistrationModal.vue?vue&type=template&id=32651323&scoped=true&ts=true"
import script from "./UserRegistrationModal.vue?vue&type=script&lang=ts"
export * from "./UserRegistrationModal.vue?vue&type=script&lang=ts"

import "./UserRegistrationModal.vue?vue&type=style&index=0&id=32651323&lang=postcss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32651323"]])

export default __exports__